import {
	RUNTIME_CONFIG,
} from '@appConf/runtime.conf';

export const getEnv = (hostname?: string, port?: string): string => {
	const currentDomain = hostname ?? window.location.hostname;
	const currentPort = port ?? window.location.port;
	const isDevEnv = currentDomain.includes('localhost') || currentPort === '5173';

	if(isDevEnv || currentDomain.includes('-dev')) {
		return 'dev';
	} else if(currentDomain.includes('-staging')) {
		return 'staging';
	} else if(currentDomain.includes('-test')) {
		return 'test';
	} else {
		return 'prod';
	}
};

export const getApiDomainByEnv = (apiServiceUrl?: string): string => {
	const isLegacyLocal = RUNTIME_CONFIG.IS_LEGACY_LOCAL_ENV === 'true';
	const isNotLegacyLocal = RUNTIME_CONFIG.IS_LEGACY_LOCAL_ENV === 'false';
	const isDev = RUNTIME_CONFIG.IS_DEV === true;

	if (apiServiceUrl) {
		if (isLegacyLocal && isDev) {
			return 'http://localhost:3000';
		}
		if (isNotLegacyLocal && isDev) {
			return 'https://api.lpdi-dev.com';
		}
		return apiServiceUrl;
	}

	if (isLegacyLocal && isDev) {
		return 'http://localhost:8080';
	}
	if (isNotLegacyLocal && isDev) {
		return 'https://www.lpdi-dev.com';
	}

	return '';
};
